var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-pdv"},[_c('PageHeader',{attrs:{"title":_vm.i18nAverageTime}}),(_vm.loading)?_c('b-skeleton-img'):_c('apexchart',{staticClass:"apex-charts",attrs:{"height":"260","type":"line","series":_vm.series,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }